import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/StateLabel/StateLabel.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/state-label/react/latest'} mdxType="DeprecationBanner" />
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <StateLabel status="issueOpened">Open</StateLabel>
  <StateLabel status="issueClosed">Closed</StateLabel>
  <StateLabel status="issueClosedNotPlanned">Closed</StateLabel>
  <StateLabel status="pullOpened">Open</StateLabel>
  <StateLabel status="pullClosed">Closed</StateLabel>
  <StateLabel status="pullMerged">Merged</StateLabel>
  <StateLabel status="pullQueued">Queued</StateLabel>
  <StateLabel status="draft">Draft</StateLabel>
  <StateLabel status="issueDraft">Draft</StateLabel>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      